import { Component, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserPreferencesService } from '@compumark/user-preferences-backend-specifications';
import { EMPTY, Subscription } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

import { EmailAlertsDialogComponent } from '../email-alerts-dialog/email-alerts-dialog.component';
import { EmailAlertsModel } from '../models/email-alerts.model';
import { UserPreferencesModel } from '../models/user-preferences.model';

@Component({
  selector: 'app-email-alerts',
  templateUrl: './email-alerts.component.html',
  standalone: false,
})
export class EmailAlertsComponent {
  private dialog = inject(MatDialog);
  private userPreferencesService = inject(UserPreferencesService);

  private subscription: Subscription | undefined;

  openModalWindow(): void {
    if (this.subscription && !this.subscription.closed) {
      return;
    }
    this.subscription = this.userPreferencesService
      .getUserPreferences()
      .pipe(
        map(
          (result: any) =>
            (result.preference as UserPreferencesModel).emailAlerts,
        ),
        map((userPreferences) => {
          return this.openDialog(userPreferences);
        }),
        switchMap((dialogRef: MatDialogRef<EmailAlertsDialogComponent>) => {
          return dialogRef?.afterClosed?.() ?? EMPTY;
        }),
        filter((updatedUserPrefrence) => !!updatedUserPrefrence),
        switchMap((updatedUserPrefrence) => {
          const saveUserPreferences$ =
            this.userPreferencesService.saveUserPreferences({
              emailAlerts: updatedUserPrefrence,
            });

          return saveUserPreferences$ ?? EMPTY;
        }),
      )
      .subscribe();
  }

  private openDialog(
    userPreferences: EmailAlertsModel,
  ): MatDialogRef<EmailAlertsDialogComponent> {
    return this.dialog.open(EmailAlertsDialogComponent, {
      width: '920px',
      height: '346px',
      data: userPreferences,
    });
  }
}
